import CryptoJS from 'crypto-js';

import { environment } from "../../../environments/environment";

export class EncryptUtil {
  private static secretKey: string = environment.ENCRYPT_KEY;
  private static ivKey: string = environment.ENCRYPT_IV;

  /**
   * @description Encode a value with base 64
   * @param {string} value to encrypt with properties
   * @return {string}
   */
  public static encodeValue(value: string): string {
    return btoa(value);
  }

  /**
   * @description Decode value to persist information
   * @param {string} encodeValue value encoded to decoded 
   * @return {string}
   */
  public static decodeValue(encodeValue: string): string {
    return atob(encodeValue);
  }

  /**
   * @description encrypt object with 
   * @param {any} data information to encrypt
   * @return {string} encrypted data
   */
  public static encryptObject(data: any): string {
    const stringData = JSON.stringify(data);

    const key = CryptoJS.enc.Hex.parse(this.secretKey);
    const iv = CryptoJS.enc.Hex.parse(this.ivKey);

    const encrypted = CryptoJS.AES.encrypt(stringData, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString();
  }

  /**
   * @description Decrypt object to show original structure
   * @param {string} encryptedData to decrypt 
   * @return {any} - object with information
   */
  public static decryptObject(encryptedData: string): any {
    const key = CryptoJS.enc.Hex.parse(this.secretKey);
    const iv = CryptoJS.enc.Hex.parse(this.ivKey);

    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    const decryptedData = decrypted.toString(CryptoJS.enc.Utf8);

    return JSON.parse(decryptedData);
  }

  /**
   * @description Encrypt a string with AES method
   * @param {string} text to encrypt
   * @return {string} text encrypted
   */
  public static encryptText(text: string): string {
    const key = CryptoJS.enc.Hex.parse(this.secretKey);
    const iv = CryptoJS.enc.Hex.parse(this.ivKey);

    const encrypted = CryptoJS.AES.encrypt(text, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }

  /**
   * @description Decrypt text encrypted with AES method
   * @param {string} cipherText text encrypted
   * @return {string} original text decrypted
   */
  public static decryptText(cipherText: string): string {
    const key = CryptoJS.enc.Hex.parse(this.secretKey);
    const iv = CryptoJS.enc.Hex.parse(this.ivKey);

    const decrypted = CryptoJS.AES.decrypt(cipherText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}